export default {
    props: {
        show: Boolean
    },
    name: 'ContactUs',
    methods: {
        goToContactUs() {
            this.$router.push({ name: 'ContactUs' });
        }
    }
};
